// Original select options map (without age for now)
export const selectOptionsMap = {
  community: [],
  nationality: [],
  marital_status: [],
  height: Array.from({ length: 131 }, (_, i) => {
    const value = 100 + i;
    return { label: `${value} cm`, value: value };
  }),
  weight: Array.from({ length: 121 }, (_, i) => {
    const value = 30 + i;
    return { label: `${value} kg`, value: value };
  }),
};

export const selectFields = [
  { label: "Age", key: "age", multiple: false },
  { label: "Community", key: "community", multiple: true },
  { label: "Nationality", key: "nationality", multiple: true },
  { label: "Marital status", key: "marital_status", multiple: true },
];
